export default __webpack_public_path__ + "static/media/On_the_Cool_Side.8a5c8907.mp3";